export const socketAction = (type, ref) => {
    return{
        type: type,
        ref: ref
    }
}